import connectToStores from "alt-utils/lib/connectToStores";
import className from "classnames";
import noop from "lodash/noop";
import PropTypes from "prop-types";
import React, { Component } from "react";

import { author as authorPropType } from "../ChatPropTypes";

import AttachmentStore from "../../../stores/chat/AttachmentStore";
import Author from "../Author";
import { createSanitizedMarkup, postMessageToParent } from "../../../utils/Utils";
import ImageAttachment from "../../common/ImageAttachment";
import { PostMessage } from "../../../constants/chat";

class ResponseMessage extends Component {
    static getStores() {
        return [AttachmentStore];
    }

    static getPropsFromStores({ id }) {
        return {
            attachments: AttachmentStore.getForMessage(id),
        };
    }

    onCloseImageAttachment() {
        postMessageToParent(PostMessage.CLOSE_IMAGE_OVERLAY);
    }

    onOpenImageAttachment() {
        postMessageToParent(PostMessage.OPEN_IMAGE_OVERLAY);
    }

    render() {
        const {
            attachments,
            author,
            dateCreated,
            id,
            isFirstResponseMessage,
            isLoading,
            messageText,
            showChatbotNameAndAvatar,
        } = this.props;
        const containerClasses = className({
            "message-container": true,
            "is-poster": author.isOriginalPoster,
            "is-expert": !author.isOriginalPoster,
            "is-loading": isLoading,
        });
        const imageAttachmentClasses = className("message-container", "is-image", {
            "is-expert": !author.isOriginalPoster,
            "is-poster": author.isOriginalPoster,
        });

        return (
            <li data-date-created={dateCreated} data-message-id={id}>
                <div className={containerClasses}>
                    {!author.isOriginalPoster && (!author.isChatbot || showChatbotNameAndAvatar) && (
                        <Author
                            avatarSrc={author.avatarSrc}
                            isCertified={author.isCertified}
                            isElite={author.isElite}
                            isOfficial={author.isOfficial}
                            isFirstResponseMessage={isFirstResponseMessage}
                            name={author.name}
                            reputation={author.reputation}
                        />
                    )}
                    <p className="body" dangerouslySetInnerHTML={createSanitizedMarkup(messageText)} />
                </div>

                {attachments.map(({ id: attachmentId, url }) => (
                    <ImageAttachment
                        alt={i18n.t("rtm.text.image_uploaded_by", {
                            poster: author.isOriginalPoster ? i18n.t("rtm.text.user") : i18n.t("rtm.text.expert"),
                        })}
                        className={imageAttachmentClasses}
                        key={attachmentId}
                        onCloseOriginalImage={this.onCloseImageAttachment}
                        onOpenOriginalImage={this.onOpenImageAttachment}
                        onThumbnailLoad={this.props.scrollToBottom}
                        originalSrc={url.original}
                        thumbnailSrc={url.thumbnail}
                    />
                ))}
            </li>
        );
    }
}

ResponseMessage.defaultProps = {
    scrollToBottom: noop,
    showChatbotNameAndAvatar: false,
};

ResponseMessage.propTypes = {
    attachments: PropTypes.arrayOf(
        PropTypes.shape({
            dateCreated: PropTypes.string.isRequired,
            id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
            messageId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
            url: PropTypes.shape({
                original: PropTypes.string.isRequired,
                thumbnail: PropTypes.string.isRequired,
            }),
        })
    ).isRequired,
    author: authorPropType.isRequired,
    dateCreated: PropTypes.string.isRequired,
    id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    isFirstResponseMessage: PropTypes.bool.isRequired,
    isLoading: PropTypes.bool.isRequired,
    messageText: PropTypes.string.isRequired,
    scrollToBottom: PropTypes.func,
    showChatbotNameAndAvatar: PropTypes.bool,
};

export default connectToStores(ResponseMessage);
